(function () {
    function parseProductJsonFromPage() {
      var el = document.querySelector('script[type="application/json"][data-tryon-page-product]');
      if (!el || !el.textContent || !String(el.textContent).trim()) {
        return null;
      }
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn("[TryOn] Invalid product JSON in page.", e);
        return null;
      }
    }
  
    /** Strip HTML from product body; decode entities via DOM. */
    function htmlToPlainText(html) {
      if (html == null || html === "") {
        return "";
      }
      var s = String(html).trim();
      if (!s) {
        return "";
      }
      var tmp = document.createElement("div");
      tmp.innerHTML = s;
      var text = tmp.textContent || tmp.innerText || "";
      return text.replace(/\s+/g, " ").trim();
    }
  
    /** garment_description: plain-text description, type, tags (no title). */
    function buildGarmentDescriptionKeyValues(p) {
      if (!p || typeof p !== "object") {
        return {
          description: "",
          type: "",
          tags: []
        };
      }
      var descRaw = p.description != null ? p.description : p.body_html;
      var ptype = p.type != null ? p.type : p.product_type;
      var tags = p.tags;
      if (!Array.isArray(tags)) {
        tags = tags != null && String(tags).length ? [String(tags)] : [];
      }
      return {
        description: htmlToPlainText(descRaw),
        type: ptype != null ? String(ptype) : "",
        tags: tags
      };
    }
  
    function getGarmentDescriptionForApi() {
      var p = parseProductJsonFromPage();
      return buildGarmentDescriptionKeyValues(p);
    }

    function getProductSubmissionMeta() {
      var p = parseProductJsonFromPage();
      var productName = p && p.title ? String(p.title) : "";
      var productUrl = "";
      if (p && p.url) {
        productUrl = String(p.url);
        if (productUrl.indexOf("http") !== 0) {
          productUrl = window.location.origin + (productUrl.charAt(0) === "/" ? productUrl : "/" + productUrl);
        }
      } else {
        productUrl = window.location.href.split("#")[0];
      }
      var code = "";
      if (p) {
        if (p.handle) {
          code = String(p.handle);
        } else if (p.id) {
          code = String(p.id);
        }
      }
      return {
        productName: productName,
        productUrl: productUrl,
        code: code
      };
    }
  
    /** Browser max JPEG quality for capture, watermark, and exported files. */
    var TRYON_JPEG_QUALITY = 1;
    var TRYON_DAILY_STATE_KEY = "br_tryon_daily_state";
    var TRYON_LEGACY_STORAGE_KEYS = [
      "br_tryon_daily_generation",
      "br_tryon_successful_generation_count"
    ];
  
    function getLocalDateKey() {
      var d = new Date();
      var m = d.getMonth() + 1;
      var day = d.getDate();
      return d.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
    }
  
    function createFreshDailyState() {
      return {
        date: getLocalDateKey(),
        generationCount: 0,
        contactSubmitted: false,
        contact: null
      };
    }
  
    function clearTryOnDailyStorage() {
      var i;
      try {
        localStorage.removeItem(TRYON_DAILY_STATE_KEY);
        for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
          localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
        }
      } catch (e) {
        /* ignore */
      }
    }
  
    /** Drop yesterday's (or invalid) data — we only keep one small record for today. */
    function purgeStaleTryOnDailyStorage() {
      var today = getLocalDateKey();
      var i;
      try {
        for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
          localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
        }
        var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
        if (!raw) {
          return;
        }
        var parsed = JSON.parse(raw);
        if (!parsed || parsed.date !== today) {
          clearTryOnDailyStorage();
        }
      } catch (e) {
        clearTryOnDailyStorage();
      }
    }
  
    function readDailyState() {
      try {
        var today = getLocalDateKey();
        var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
        if (!raw) {
          return createFreshDailyState();
        }
        var parsed = JSON.parse(raw);
        if (!parsed || parsed.date !== today) {
          clearTryOnDailyStorage();
          return createFreshDailyState();
        }
        var genCount = parsed.generationCount;
        if (genCount == null && parsed.count != null) {
          genCount = parseInt(parsed.count, 10);
        } else {
          genCount = parseInt(genCount, 10);
        }
        if (isNaN(genCount) || genCount < 0) {
          genCount = 0;
        }
        var contact = null;
        if (parsed.contact && typeof parsed.contact === "object") {
          contact = {
            name: parsed.contact.name != null ? String(parsed.contact.name) : "",
            phone: parsed.contact.phone != null ? String(parsed.contact.phone) : "",
            countryCode:
              parsed.contact.countryCode != null ? String(parsed.contact.countryCode) : ""
          };
        }
        return {
          date: today,
          generationCount: genCount,
          contactSubmitted: parsed.contactSubmitted === true,
          contact: contact
        };
      } catch (e) {
        clearTryOnDailyStorage();
        return createFreshDailyState();
      }
    }
  
    function writeDailyState(state) {
      try {
        localStorage.setItem(TRYON_DAILY_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        /* ignore */
      }
    }
  
    function incrementSuccessfulGenerationCount() {
      var state = readDailyState();
      state.generationCount = (state.generationCount || 0) + 1;
      writeDailyState(state);
    }
  
    function persistContactSubmitted(payload) {
      if (!payload) {
        return;
      }
      var state = readDailyState();
      state.contactSubmitted = true;
      state.contact = {
        name: payload.name,
        phone: payload.phoneE164 || payload.phone,
        countryCode: payload.countryCode || "",
        code: payload.code || ""
      };
      writeDailyState(state);
    }
  
    function normalizePhoneDigits(value, maxLen) {
      return String(value || "").replace(/\D/g, "").slice(0, maxLen != null ? maxLen : 15);
    }

    function getShopifyPhoneUtil() {
      if (!window.libphonenumber || !libphonenumber.PhoneNumberUtil) {
        return null;
      }
      return libphonenumber.PhoneNumberUtil.getInstance();
    }

    function getDialCodeForRegion(isoCode) {
      var util = getShopifyPhoneUtil();
      if (!util || !isoCode) {
        return "";
      }
      try {
        return String(util.getCountryCodeForRegion(String(isoCode).toUpperCase()));
      } catch (e) {
        return "";
      }
    }

    function validatePhoneForRegion(nationalNumber, regionCode) {
      var digits = normalizePhoneDigits(nationalNumber);
      if (!digits) {
        return false;
      }
      var util = getShopifyPhoneUtil();
      if (!util) {
        return digits.length >= 6 && digits.length <= 15;
      }
      try {
        var parsed = util.parse(String(digits), String(regionCode).toUpperCase());
        return util.isValidNumberForRegion(parsed, String(regionCode).toUpperCase());
      } catch (e) {
        return false;
      }
    }

    function formatPhoneE164(nationalNumber, regionCode) {
      var digits = normalizePhoneDigits(nationalNumber);
      if (!digits) {
        return "";
      }
      var util = getShopifyPhoneUtil();
      if (!util) {
        var dial = getDialCodeForRegion(regionCode);
        return dial ? "+" + dial + digits : digits;
      }
      try {
        var parsed = util.parse(String(digits), String(regionCode).toUpperCase());
        return util.format(parsed, libphonenumber.PhoneNumberFormat.E164);
      } catch (e) {
        return "";
      }
    }

    function splitPhoneNumber(rawPhone, fallbackRegion) {
      var util = getShopifyPhoneUtil();
      if (!util || !rawPhone) {
        return null;
      }
      try {
        var parsed = util.parse(String(rawPhone), fallbackRegion || undefined);
        var region = util.getRegionCodeForNumber(parsed) || fallbackRegion || "";
        var national = util.getNationalSignificantNumber(parsed);
        return {
          region: region,
          national: national,
          e164: util.format(parsed, libphonenumber.PhoneNumberFormat.E164)
        };
      } catch (e) {
        return null;
      }
    }

    function getRegionDisplayName(isoCode, displayNames) {
      var iso = String(isoCode || "").toUpperCase();
      if (!iso) {
        return "";
      }
      if (displayNames) {
        try {
          var label = displayNames.of(iso);
          if (label && label !== iso) {
            return label;
          }
        } catch (e) {
          /* ignore */
        }
      }
      return iso;
    }

    function regionsToArray(regions) {
      if (!regions) {
        return [];
      }
      if (Array.isArray(regions)) {
        return regions;
      }
      if (typeof regions.length === "number") {
        return Array.prototype.slice.call(regions);
      }
      var list = [];
      if (typeof regions.forEach === "function") {
        regions.forEach(function (region) {
          list.push(region);
        });
      }
      return list;
    }

    /** Global country list — same libphonenumber regions Shopify @shopify/phone uses. */
    function buildGlobalPhoneCountrySelect(selectEl) {
      if (!selectEl || selectEl.dataset.tryonCountriesBuilt === "true") {
        return !!selectEl;
      }

      var util = getShopifyPhoneUtil();
      if (!util) {
        return false;
      }

      var defaultIso = String(
        selectEl.getAttribute("data-default-country") || "IN"
      ).toUpperCase();
      var popularList = [];
      try {
        popularList = JSON.parse(selectEl.getAttribute("data-popular-countries") || "[]");
      } catch (e) {
        popularList = [];
      }
      popularList = popularList
        .map(function (code) {
          return String(code || "").toUpperCase();
        })
        .filter(function (code, index, arr) {
          return code && arr.indexOf(code) === index;
        });

      if (!popularList.length) {
        popularList = [defaultIso, "US", "GB", "CA", "AU"].filter(function (code, index, arr) {
          return code && arr.indexOf(code) === index;
        });
      }

      var displayNames = null;
      try {
        if (typeof Intl !== "undefined" && Intl.DisplayNames) {
          displayNames = new Intl.DisplayNames(["en"], { type: "region" });
        }
      } catch (e2) {
        displayNames = null;
      }

      var all = [];
      regionsToArray(util.getSupportedRegions()).forEach(function (iso) {
        iso = String(iso || "").toUpperCase();
        var dial = getDialCodeForRegion(iso);
        if (!dial) {
          return;
        }
        all.push({
          iso: iso,
          dial: dial,
          name: getRegionDisplayName(iso, displayNames)
        });
      });

      all.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      var byIso = {};
      all.forEach(function (item) {
        byIso[item.iso] = item;
      });

      selectEl.innerHTML = "";

      function appendOption(item) {
        var opt = document.createElement("option");
        opt.value = item.iso;
        opt.textContent = "+" + item.dial + " " + item.name;
        opt.setAttribute("data-dial-code", item.dial);
        opt.setAttribute("data-country-name", item.name);
        if (item.iso === defaultIso) {
          opt.selected = true;
        }
        return opt;
      }

      var popularGroup = document.createElement("optgroup");
      popularGroup.label = "Popular";
      var popularAdded = 0;
      popularList.forEach(function (iso) {
        if (byIso[iso]) {
          popularGroup.appendChild(appendOption(byIso[iso]));
          popularAdded += 1;
        }
      });
      if (popularAdded) {
        selectEl.appendChild(popularGroup);
      }

      var allGroup = document.createElement("optgroup");
      allGroup.label = popularAdded ? "All countries" : "Countries";
      all.forEach(function (item) {
        allGroup.appendChild(appendOption(item));
      });
      selectEl.appendChild(allGroup);

      if (!selectEl.value && all.length) {
        selectEl.value = defaultIso;
      }

      selectEl.dataset.tryonCountriesBuilt = "true";
      return true;
    }

    function ensureGlobalPhoneCountrySelect(selectEl) {
      if (!selectEl) {
        return false;
      }
      if (buildGlobalPhoneCountrySelect(selectEl)) {
        return true;
      }
      return false;
    }
  
    /** Prefer exact API error text for user-facing status messages. */
    function extractTryonApiErrorMessage(payload, bodyText, httpStatus) {
      var fallback =
        httpStatus != null ? "Server request failed (" + httpStatus + ")." : "Try-on failed. Please retry.";
  
      if (payload && typeof payload === "object") {
        if (typeof payload.error === "string" && payload.error.trim()) {
          return payload.error.trim();
        }
        if (payload.error && typeof payload.error === "object") {
          if (typeof payload.error.message === "string" && payload.error.message.trim()) {
            return payload.error.message.trim();
          }
          if (typeof payload.error.detail === "string" && payload.error.detail.trim()) {
            return payload.error.detail.trim();
          }
        }
        if (typeof payload.message === "string" && payload.message.trim()) {
          return payload.message.trim();
        }
        if (typeof payload.detail === "string" && payload.detail.trim()) {
          return payload.detail.trim();
        }
        if (typeof payload.reason === "string" && payload.reason.trim()) {
          return payload.reason.trim();
        }
        if (Array.isArray(payload.errors) && payload.errors.length) {
          var parts = payload.errors
            .map(function (entry) {
              if (typeof entry === "string") {
                return entry.trim();
              }
              if (entry && typeof entry.message === "string") {
                return entry.message.trim();
              }
              if (entry && typeof entry.msg === "string") {
                return entry.msg.trim();
              }
              return "";
            })
            .filter(Boolean);
          if (parts.length) {
            return parts.join(" ");
          }
        }
      }
  
      if (bodyText && typeof bodyText === "string") {
        var trimmed = bodyText.trim();
        if (trimmed) {
          try {
            var parsed = JSON.parse(trimmed);
            var fromJson = extractTryonApiErrorMessage(parsed, "", httpStatus);
            if (fromJson && fromJson.indexOf("Server request failed") !== 0) {
              return fromJson;
            }
          } catch (e) {
            if (trimmed.length < 800 && trimmed.indexOf("<") !== 0) {
              return trimmed;
            }
          }
        }
      }
  
      return fallback;
    }
  
    purgeStaleTryOnDailyStorage();
  
    function initTryOn(root) {
      if (!root || root.dataset.tryonReady === "true") {
        return;
      }
      root.dataset.tryonReady = "true";
  
      var modal = root.parentElement.querySelector("[data-tryon-modal]");
      if (!modal) {
        return;
      }
  
      var instanceId = root.getAttribute("data-tryon-instance");
      var openButtons;
      if (instanceId) {
        openButtons = document.querySelectorAll(
          '[data-tryon-instance="' + instanceId + '"][data-tryon-open]'
        );
      } else {
        openButtons = root.querySelectorAll("[data-tryon-open]");
      }
      var closeButtons = modal.querySelectorAll("[data-tryon-close]");
      var garmentImage = modal.querySelector("[data-tryon-garment]");
      var video = modal.querySelector("[data-tryon-video]");
      var canvas = modal.querySelector("[data-tryon-canvas]");
      var previewImage = modal.querySelector("[data-tryon-preview-image]");
      var resultImage = modal.querySelector("[data-tryon-result-image]");
      var uploadBox = modal.querySelector("[data-tryon-upload-trigger]");
      var cameraButton = modal.querySelector("[data-tryon-camera]");
      var chooseButton = modal.querySelector("[data-tryon-choose]");
      var fileInput = modal.querySelector("[data-tryon-file]");
      var statusNode = modal.querySelector("[data-tryon-status]");
      var loaderNode = modal.querySelector("[data-tryon-loader]");
      var loaderTextNode = modal.querySelector("[data-tryon-loader-text]");
      var cameraInstructionNode = modal.querySelector("[data-tryon-camera-instruction]");
      var cameraFlipButton = modal.querySelector("[data-tryon-camera-flip]");
      var countdownNode = modal.querySelector("[data-tryon-countdown]");
      var downloadButton = modal.querySelector("[data-tryon-download]");
      var shareButton = modal.querySelector("[data-tryon-share]");
      var regenerateButton = modal.querySelector("[data-tryon-regenerate]");
      var detailsModal = modal.querySelector("[data-tryon-details-modal]");
      var detailsTitleEl = modal.querySelector("[data-tryon-details-title]");
      var detailsInnerDialog = modal.querySelector("[data-tryon-details-dialog]");
      var detailsNameInput = modal.querySelector("[data-tryon-customer-name]");
      var detailsPhoneInput = modal.querySelector("[data-tryon-customer-phone]");
      var detailsPhoneCountry = modal.querySelector("[data-tryon-phone-country]");
      var detailsErrorNode = modal.querySelector("[data-tryon-details-error]");
      var detailsConsentInput = modal.querySelector("[data-tryon-consent]");
      var detailsSubmitButton = modal.querySelector("[data-tryon-details-submit]");
      var detailsCancelButton = modal.querySelector("[data-tryon-details-cancel]");
      var toolbarBusyEl = modal.querySelector("[data-tryon-toolbar-busy]");
      var toolbarBusyTextEl = modal.querySelector("[data-tryon-toolbar-busy-text]");
      var captureButton = modal.querySelector("[data-tryon-capture-btn]");
      var activeGarmentOverride = "";
  
      var stream = null;
      var cameraFacingMode = "user";
      var isCameraCaptureInProgress = false;
      var bodySeenStreak = 0;
      var bodyLostStreak = 0;
      var BODY_SEEN_CHECKS = 2;
      var BODY_LOST_CHECKS = 4;
      var captureTimer = null;
      var bodyCheckTimer = null;
      var countdownInterval = null;
      var pose = null;
      var poseReady = false;
      var poseFramePending = false;
      var poseLoopActive = false;
      var latestPoseLandmarks = null;
      var currentState = "empty";
      var isLoading = false;
      var isToolbarActionBusy = false;
      var isDetailsSubmitBusy = false;
      var detailsSubmitLabel = "Continue";
      var loadingTextInterval = null;
      var lastSourceBlob = null;
      var generatedBlob = null;
      var generatedFilename = "try-on-result.jpg";
      var loadingMessages = [
        "Analyzing model pose...",
        "Analyzing garment details...",
        "Fitting garment on your photo...",
        "Rendering final try-on image..."
      ];
      var contextMenuBlocker = null;
      var pageBackdrop = null;

      function initPhoneCountryDropdown() {
        if (!detailsPhoneCountry) {
          return;
        }
        if (!ensureGlobalPhoneCountrySelect(detailsPhoneCountry)) {
          window.setTimeout(initPhoneCountryDropdown, 120);
          return;
        }
        applyDefaultPhoneFromCustomer();
      }

      function getSelectedDialCode() {
        if (!detailsPhoneCountry) {
          return "";
        }
        var selected = detailsPhoneCountry.options[detailsPhoneCountry.selectedIndex];
        if (selected) {
          var fromOption = selected.getAttribute("data-dial-code");
          if (fromOption) {
            return fromOption;
          }
        }
        return getDialCodeForRegion(getSelectedPhoneRegion());
      }

      function getSelectedPhoneRegion() {
        if (!detailsPhoneCountry) {
          return "IN";
        }
        return String(detailsPhoneCountry.value || "IN").toUpperCase();
      }

      function applyDefaultPhoneFromCustomer() {
        if (!detailsPhoneInput || !detailsPhoneCountry) {
          return;
        }
        var raw = detailsPhoneInput.getAttribute("data-tryon-default-phone") || "";
        if (!raw) {
          return;
        }
        var split = splitPhoneNumber(raw, getSelectedPhoneRegion());
        if (!split) {
          detailsPhoneInput.value = normalizePhoneDigits(raw);
          return;
        }
        if (split.region) {
          detailsPhoneCountry.value = split.region;
        }
        detailsPhoneInput.value = split.national || normalizePhoneDigits(raw);
      }

      initPhoneCountryDropdown();

      if (detailsPhoneCountry) {
        detailsPhoneCountry.addEventListener("change", function () {
          setInputErrorState(detailsPhoneCountry, false);
          setInputErrorState(detailsPhoneInput, false);
          if (
            detailsErrorNode &&
            (detailsErrorNode.textContent.indexOf("valid mobile") !== -1 ||
              detailsErrorNode.textContent.indexOf("mobile number") !== -1)
          ) {
            setDetailsError("");
          }
        });
      }

      if (detailsPhoneInput) {
        detailsPhoneInput.addEventListener("input", function () {
          var digits = normalizePhoneDigits(detailsPhoneInput.value);
          if (detailsPhoneInput.value !== digits) {
            detailsPhoneInput.value = digits;
          }
          setInputErrorState(detailsPhoneInput, false);
          if (
            detailsErrorNode &&
            (detailsErrorNode.textContent.indexOf("valid mobile") !== -1 ||
              detailsErrorNode.textContent.indexOf("mobile number") !== -1)
          ) {
            setDetailsError("");
          }
        });
        detailsPhoneInput.addEventListener("paste", function (event) {
          event.preventDefault();
          var pasted = "";
          try {
            pasted = (event.clipboardData || window.clipboardData).getData("text");
          } catch (e) {
            pasted = "";
          }
          var combined = detailsPhoneInput.value + pasted;
          var split = splitPhoneNumber(combined, getSelectedPhoneRegion());
          if (split && split.national) {
            if (split.region && detailsPhoneCountry) {
              detailsPhoneCountry.value = split.region;
            }
            detailsPhoneInput.value = split.national;
          } else {
            detailsPhoneInput.value = normalizePhoneDigits(combined);
          }
        });
      }
  
      if (!openButtons.length || !uploadBox || !fileInput || !video || !canvas || !previewImage || !resultImage) {
        return;
      }
  
      /* Modal must live under document.body so position:fixed + z-index sit above .header-section (z-index:50).
         Nested inside product markup it can stack under the sticky header due to ancestor stacking contexts. */
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
  
      function ensurePageBackdrop() {
        if (!pageBackdrop) {
          pageBackdrop = document.createElement("div");
          pageBackdrop.className = "br-tryon-page-backdrop";
          pageBackdrop.setAttribute("aria-hidden", "true");
          pageBackdrop.addEventListener("click", function () {
            closeModal();
          });
        }
        if (pageBackdrop.parentElement !== document.body) {
          document.body.appendChild(pageBackdrop);
        }
        return pageBackdrop;
      }

      function showPageBackdrop() {
        var backdrop = ensurePageBackdrop();
        backdrop.classList.add("is-visible");
        backdrop.setAttribute("aria-hidden", "false");
      }

      function hidePageBackdrop() {
        if (!pageBackdrop) {
          return;
        }
        pageBackdrop.classList.remove("is-visible");
        pageBackdrop.setAttribute("aria-hidden", "true");
      }

      function setStatus(message, variant) {
        if (!statusNode) {
          return;
        }
        statusNode.textContent = message || "";
        statusNode.classList.toggle("br-tryon-status--error", variant === "error");
      }
  
      function setCameraInstruction(message) {
        if (!cameraInstructionNode) {
          return;
        }
        cameraInstructionNode.textContent = message;
      }
  
      function setDetailsError(message) {
        if (detailsErrorNode) {
          detailsErrorNode.textContent = message || "";
        }
      }
  
      function getDetailsBusyLabel(actionLabel) {
        if (actionLabel === "generate") {
          return "Generating…";
        }
        if (actionLabel === "share") {
          return "Sharing…";
        }
        return "Downloading…";
      }
  
      function setDetailsSubmitBusy(busy, busyText) {
        isDetailsSubmitBusy = busy;
        if (detailsModal) {
          detailsModal.setAttribute("data-submit-busy", busy ? "true" : "false");
        }
        if (detailsSubmitButton) {
          detailsSubmitButton.disabled = busy;
          detailsSubmitButton.classList.toggle("is-busy", busy);
          detailsSubmitButton.setAttribute("aria-busy", busy ? "true" : "false");
          detailsSubmitButton.textContent = busy ? busyText || "Please wait…" : detailsSubmitLabel;
        }
        if (detailsCancelButton) {
          detailsCancelButton.disabled = busy;
        }
        if (detailsNameInput) {
          detailsNameInput.disabled = busy;
        }
        if (detailsPhoneInput) {
          detailsPhoneInput.disabled = busy;
        }
        if (detailsPhoneCountry) {
          detailsPhoneCountry.disabled = busy;
        }
        if (detailsConsentInput) {
          detailsConsentInput.disabled = busy;
        }
      }
  
      function setInputErrorState(input, hasError) {
        if (!input) {
          return;
        }
        input.classList.toggle("br-tryon-input-error", !!hasError);
      }
  
      function setUploadState(state) {
        currentState = state;
        uploadBox.setAttribute("data-state", state);
      }
  
      function setCountdownValue(value) {
        if (!countdownNode) {
          return;
        }
        if (value) {
          countdownNode.textContent = String(value);
          uploadBox.setAttribute("data-countdown-active", "true");
        } else {
          countdownNode.textContent = "";
          uploadBox.setAttribute("data-countdown-active", "false");
        }
      }
  
      function setLoading(value, fixedMessage) {
        isLoading = value;
        uploadBox.setAttribute("data-loading", value ? "true" : "false");
        if (loaderNode) {
          loaderNode.setAttribute("aria-hidden", value ? "false" : "true");
        }
  
        if (loadingTextInterval) {
          clearInterval(loadingTextInterval);
          loadingTextInterval = null;
        }
        if (!loaderTextNode) {
          return;
        }
  
        if (value) {
          if (fixedMessage) {
            loaderTextNode.textContent = fixedMessage;
          } else {
            var messageIndex = 0;
            loaderTextNode.textContent = loadingMessages[messageIndex];
            loadingTextInterval = setInterval(function () {
              messageIndex = (messageIndex + 1) % loadingMessages.length;
              loaderTextNode.textContent = loadingMessages[messageIndex];
            }, 1400);
          }
        } else {
          loaderTextNode.textContent = loadingMessages[0];
        }
      }
  
      function setToolbarActionLoading(active, message) {
        isToolbarActionBusy = !!active;
        uploadBox.setAttribute("data-toolbar-busy", active ? "true" : "false");
        if (toolbarBusyEl) {
          if (active) {
            toolbarBusyEl.removeAttribute("hidden");
          } else {
            toolbarBusyEl.setAttribute("hidden", "");
          }
        }
        if (toolbarBusyTextEl) {
          toolbarBusyTextEl.textContent = active && message ? message : "";
        }
      }
  
      function nextPaint() {
        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            requestAnimationFrame(resolve);
          });
        });
      }
  
      /** Live store URL from Liquid (shop.url); used when theme dev serves images on localhost. */
      function getTryonStoreOrigin() {
        var origin = (modal.dataset.tryonStoreOrigin || "").trim().replace(/\/$/, "");
        if (origin) {
          return origin;
        }
        if (window.Shopify && Shopify.shop) {
          return "https://" + String(Shopify.shop).replace(/\/$/, "");
        }
        return "";
      }
  
      function toApiAccessibleGarmentUrl(url) {
        if (!url || typeof url !== "string") {
          return "";
        }
        var trimmed = url.trim();
        if (!trimmed) {
          return "";
        }
        try {
          var parsed = new URL(trimmed, window.location.href);
          if (parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost") {
            var storeOrigin = getTryonStoreOrigin();
            if (storeOrigin) {
              return storeOrigin + parsed.pathname + parsed.search;
            }
          }
          return parsed.href;
        } catch (e) {
          return trimmed;
        }
      }
  
      function getProductDetailRoot() {
        return (
          document.querySelector("media-gallery") ||
          document.querySelector(".product") ||
          document.querySelector(".thb-product-detail")
        );
      }

      function imageUrlFrom(node) {
        if (!node) {
          return "";
        }
        return node.currentSrc || node.src || node.getAttribute("src") || "";
      }

      function imageFromMediaContainer(container) {
        if (!container) {
          return "";
        }
        var imageNode =
          container.querySelector(".product__media img") ||
          container.querySelector(".product-media-container img") ||
          container.querySelector(".product-single__media-image img") ||
          container.querySelector("img");
        return imageUrlFrom(imageNode);
      }

      function imageFromSlide(slide) {
        if (!slide) {
          return "";
        }
        return imageFromMediaContainer(slide);
      }

      function getGarmentUrlFromButton(button) {
        if (!button) {
          return "";
        }
        var fromContainer = imageFromMediaContainer(button.closest(".product-media-container"));
        if (fromContainer) {
          return fromContainer;
        }
        var fromSlide = imageFromSlide(
          button.closest(".product__media-item, .slider__slide, .product-images__slide")
        );
        return fromSlide || "";
      }

      function getActiveGarmentUrl() {
        if (activeGarmentOverride) {
          return toApiAccessibleGarmentUrl(activeGarmentOverride);
        }

        if (modal.dataset.tryonUseTestGarment === "true") {
          return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
        }

        var detailRoot = getProductDetailRoot();
        if (!detailRoot) {
          return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
        }

        // Dawn: active gallery slide.
        var dawnActiveSlide = detailRoot.querySelector(
          ".product__media-item.is-active, .product__media-item.slider__slide.is-active"
        );
        var dawnActiveUrl = imageFromSlide(dawnActiveSlide);
        if (dawnActiveUrl) {
          return toApiAccessibleGarmentUrl(dawnActiveUrl);
        }

        // Dawn: active thumbnail (aria-current or is-active).
        var dawnActiveThumb = detailRoot.querySelector(
          '.thumbnail-list__item[aria-current="true"], button.thumbnail[aria-current="true"], .thumbnail-list__item.is-active'
        );
        if (dawnActiveThumb) {
          var targetId =
            dawnActiveThumb.getAttribute("data-media-id") ||
            dawnActiveThumb.getAttribute("data-target") ||
            dawnActiveThumb.dataset.mediaId ||
            dawnActiveThumb.dataset.target;
          if (targetId) {
            var targetSlide = detailRoot.querySelector('[data-media-id="' + String(targetId) + '"]');
            if (!targetSlide && targetId.indexOf("Slide-") === 0) {
              targetSlide = detailRoot.querySelector("#" + String(targetId));
            }
            var targetUrl = imageFromSlide(targetSlide);
            if (targetUrl) {
              return toApiAccessibleGarmentUrl(targetUrl);
            }
          }
        }

        // Legacy theme: Flickity active slide.
        var selectedSlide = detailRoot.querySelector(".product-images__slide.is-selected");
        var selectedUrl = imageFromSlide(selectedSlide);
        if (selectedUrl) {
          return toApiAccessibleGarmentUrl(selectedUrl);
        }

        // Legacy theme: active slide state.
        var activeSlide = detailRoot.querySelector(".product-images__slide.is-active");
        var activeUrl = imageFromSlide(activeSlide);
        if (activeUrl) {
          return toApiAccessibleGarmentUrl(activeUrl);
        }

        // Legacy theme: active thumbnail mapped to corresponding slide id.
        var activeThumb = detailRoot.querySelector(
          ".product-thumbnail.is-active, .product-thumbnail.is-initial-selected"
        );
        if (activeThumb && activeThumb.id && activeThumb.id.indexOf("Thumb-") === 0) {
          var mappedSlide = detailRoot.querySelector(
            "#" + activeThumb.id.replace("Thumb-", "Slide-")
          );
          var mappedUrl = imageFromSlide(mappedSlide);
          if (mappedUrl) {
            return toApiAccessibleGarmentUrl(mappedUrl);
          }
        }

        // Final fallback to first gallery image.
        var fallbackImage = detailRoot.querySelector(
          ".product__media-item img, .product__media-list img, .product-images img"
        );
        return toApiAccessibleGarmentUrl(
          imageUrlFrom(fallbackImage) || modal.dataset.defaultGarment || ""
        );
      }
  
      function syncGarmentImage() {
        var garmentUrl = getActiveGarmentUrl();
        if (garmentUrl && garmentImage) {
          garmentImage.src = garmentUrl;
        }
        return garmentUrl;
      }
  
      function getCameraVideoConstraints() {
        if (cameraFacingMode === "environment") {
          return {
            facingMode: { ideal: "environment" },
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          };
        }
        return {
          facingMode: "user",
          aspectRatio: { ideal: 4 / 5 },
          width: { ideal: 864 },
          height: { ideal: 1080 }
        };
      }
  
      async function attachLiveCameraStream() {
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: getCameraVideoConstraints()
          });
        } catch (firstErr) {
          if (cameraFacingMode === "environment") {
            stream = await navigator.mediaDevices.getUserMedia({
              video: { facingMode: { ideal: "environment" } }
            });
          } else {
            throw firstErr;
          }
        }
        video.srcObject = stream;
        video.playsInline = true;
        video.setAttribute("playsinline", "");
        video.muted = true;
        await video.play();
      }
  
      function stopCamera() {
        isCameraCaptureInProgress = false;
        bodySeenStreak = 0;
        bodyLostStreak = 0;
        if (countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
        setCountdownValue("");
        if (bodyCheckTimer) {
          clearInterval(bodyCheckTimer);
          bodyCheckTimer = null;
        }
        if (captureTimer) {
          clearTimeout(captureTimer);
          captureTimer = null;
        }
        poseLoopActive = false;
        poseFramePending = false;
        latestPoseLandmarks = null;
        if (stream) {
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
          stream = null;
        }
        if (video) {
          video.srcObject = null;
        }
      }
  
      function getLandmark(index) {
        return latestPoseLandmarks && latestPoseLandmarks[index] ? latestPoseLandmarks[index] : null;
      }
  
      function hasVisibility(landmark, min) {
        return !!landmark && typeof landmark.visibility === "number" && landmark.visibility >= min;
      }
  
      function hasHalfBodyInView() {
        if (!latestPoseLandmarks || !latestPoseLandmarks.length) {
          return false;
        }
  
        var relaxed = cameraFacingMode === "environment";
        var torsoMin = relaxed ? 0.42 : 0.5;
        var limbMin = relaxed ? 0.32 : 0.45;
        var minTorsoSpan = relaxed ? 0.11 : 0.18;
  
        var leftShoulder = getLandmark(11);
        var rightShoulder = getLandmark(12);
        var leftHip = getLandmark(23);
        var rightHip = getLandmark(24);
        var nose = getLandmark(0);
  
        if (!hasVisibility(nose, 0.6)) {
          return false;
        }
        var leftKnee = getLandmark(25);
        var rightKnee = getLandmark(26);
        var leftAnkle = getLandmark(27);
        var rightAnkle = getLandmark(28);
  
        var torsoDetected =
          hasVisibility(leftShoulder, torsoMin) &&
          hasVisibility(rightShoulder, torsoMin) &&
          hasVisibility(leftHip, torsoMin) &&
          hasVisibility(rightHip, torsoMin);
        if (!torsoDetected) {
          return false;
        }
  
        var shoulderY = (leftShoulder.y + rightShoulder.y) / 2;
        var hipY = (leftHip.y + rightHip.y) / 2;
        return hipY - shoulderY > minTorsoSpan;
      }
  
      async function ensurePoseReady() {
        if (poseReady) {
          return;
        }
        if (!window.Pose) {
          throw new Error("MediaPipe not loaded. Please refresh.");
        }
  
        pose = new window.Pose({
          locateFile: function (file) {
            return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + file;
          }
        });
        pose.setOptions({
          modelComplexity: 1,
          smoothLandmarks: true,
          enableSegmentation: false,
          minDetectionConfidence: 0.5,
          minTrackingConfidence: 0.5
        });
        pose.onResults(function (results) {
          latestPoseLandmarks = results && results.poseLandmarks ? results.poseLandmarks : null;
        });
  
        poseReady = true;
      }
  
      function syncPoseConfidenceForFacing() {
        if (!pose || typeof pose.setOptions !== "function") {
          return;
        }
        var rear = cameraFacingMode === "environment";
        pose.setOptions({
          modelComplexity: 1,
          smoothLandmarks: true,
          enableSegmentation: false,
          minDetectionConfidence: rear ? 0.38 : 0.5,
          minTrackingConfidence: rear ? 0.38 : 0.5
        });
      }
  
      async function runPoseLoop() {
        if (!pose || !poseLoopActive || !video || !stream) {
          return;
        }
        if (poseFramePending) {
          requestAnimationFrame(runPoseLoop);
          return;
        }
  
        poseFramePending = true;
        try {
          await pose.send({ image: video });
        } catch (error) {
          // Continue inference loop even if one frame fails.
        }
        poseFramePending = false;
  
        if (poseLoopActive) {
          requestAnimationFrame(runPoseLoop);
        }
      }
  
      function startCountdownIfEligible() {
        // Auto-capture removed. Manual Capture button is used instead.
      }
  
      function startBodyMonitor() {
        bodySeenStreak = 0;
        bodyLostStreak = 0;
        if (bodyCheckTimer) {
          clearInterval(bodyCheckTimer);
        }
        bodyCheckTimer = setInterval(function () {
          if (currentState !== "camera" || isCameraCaptureInProgress) {
            return;
          }
  
          if (cameraFacingMode === "environment") {
            if (!stream || !video) {
              return;
            }
            var videoOk =
              video.videoWidth >= 2 && video.videoHeight >= 2 && (video.readyState === 2 || video.readyState === 4);
            if (videoOk) {
              bodyLostStreak = 0;
              bodySeenStreak += 1;
            } else {
              bodySeenStreak = 0;
            }
            if (bodySeenStreak >= BODY_SEEN_CHECKS) {
              setStatus("Body detected. Press Capture.");
              setCameraInstruction("Body detected. Press Capture.");
            } else {
              setStatus("Back camera on. Step back — full body in frame.");
              setCameraInstruction("Step back — full body in frame.");
            }
            return;
          }
  
          var detected = hasHalfBodyInView();
          if (detected) {
            bodyLostStreak = 0;
            bodySeenStreak += 1;
          } else {
            bodySeenStreak = 0;
            bodyLostStreak += 1;
          }
  
          if (bodySeenStreak >= BODY_SEEN_CHECKS) {
            setStatus("Body detected. Press Capture.");
            setCameraInstruction("Body detected. Press Capture.");
          } else if (bodyLostStreak >= BODY_LOST_CHECKS || !detected) {
            setStatus("Stand in middle for accurate outputs.");
            setCameraInstruction("Stand in middle for accurate outputs.");
          }
        }, 500);
      }
  
      function getCaptureCrop(videoWidth, videoHeight) {
        var targetRatio = 4 / 5;
        var cropWidth = videoWidth;
        var cropHeight = videoHeight;
  
        if (videoWidth / videoHeight > targetRatio) {
          cropWidth = videoHeight * targetRatio;
        } else {
          cropHeight = videoWidth / targetRatio;
        }
  
        var cropX = (videoWidth - cropWidth) / 2;
        var cropY = (videoHeight - cropHeight) / 2;
        var centeringPoints = [getLandmark(11), getLandmark(12), getLandmark(23), getLandmark(24)].filter(function (point) {
          return point && typeof point.x === "number";
        });
  
        if (centeringPoints.length) {
          var avgX =
            centeringPoints.reduce(function (sum, point) {
              return sum + point.x;
            }, 0) / centeringPoints.length;
          var desiredX = avgX * videoWidth - cropWidth / 2;
          cropX = Math.max(0, Math.min(desiredX, videoWidth - cropWidth));
        }
  
        return {
          sx: cropX,
          sy: cropY,
          sw: cropWidth,
          sh: cropHeight
        };
      }
  
      function getTargetCaptureSize() {
        var targetHeight = 1250;
        var targetWidth = Math.round((targetHeight * 4) / 5);
        return {
          width: targetWidth,
          height: targetHeight
        };
      }
  
      async function blobToDataUrl(fileBlob) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onload = function () {
            resolve(reader.result || "");
          };
          reader.onerror = function () {
            reject(new Error("Failed to read image."));
          };
          reader.readAsDataURL(fileBlob);
        });
      }
  
      function stripDataUrlToRawBase64(dataUrl) {
        if (!dataUrl || typeof dataUrl !== "string") {
          return "";
        }
        var trimmed = dataUrl.trim();
        var marker = "base64,";
        var idx = trimmed.indexOf(marker);
        if (idx !== -1) {
          return trimmed.slice(idx + marker.length);
        }
        return trimmed;
      }
  
      function canvasToJpegBlob(canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(
            function (blob) {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("Could not encode JPEG."));
              }
            },
            "image/jpeg",
            TRYON_JPEG_QUALITY
          );
        });
      }
  
      async function blobToJpegBase64(fileBlob) {
        var jpegBlob = fileBlob;
        var type = (fileBlob && fileBlob.type) || "";
        if (type.indexOf("jpeg") === -1 && type.indexOf("jpg") === -1) {
          var sourceUrl = URL.createObjectURL(fileBlob);
          try {
            var sourceImage = await imageFromUrl(sourceUrl);
            var tempCanvas = document.createElement("canvas");
            tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
            tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
            tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
            jpegBlob = await canvasToJpegBlob(tempCanvas);
          } finally {
            URL.revokeObjectURL(sourceUrl);
          }
        }
        var dataUrl = await blobToDataUrl(jpegBlob);
        return {
          base64: stripDataUrlToRawBase64(dataUrl),
          mimeType: "image/jpeg"
        };
      }
  
      async function imageUrlToJpegBase64(imageUrl) {
        var sourceImage;
        try {
          sourceImage = await imageFromUrl(imageUrl, true);
        } catch (corsErr) {
          sourceImage = await imageFromUrl(imageUrl, false);
        }
        var tempCanvas = document.createElement("canvas");
        tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
        tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
        tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
        var jpegBlob = await canvasToJpegBlob(tempCanvas);
        var dataUrl = await blobToDataUrl(jpegBlob);
        return {
          base64: stripDataUrlToRawBase64(dataUrl),
          mimeType: "image/jpeg"
        };
      }
  
      function findDecodableImageFromJson(node, depth) {
        depth = depth || 0;
        if (!node || depth > 12) {
          return null;
        }
        if (typeof node === "string") {
          try {
            var blob = dataUrlToBlob(node);
            return blob && blob.size > 0 ? blob : null;
          } catch (decodeErr) {
            return null;
          }
        }
        if (Array.isArray(node)) {
          var i;
          for (i = 0; i < node.length; i++) {
            var fromArray = findDecodableImageFromJson(node[i], depth + 1);
            if (fromArray) {
              return fromArray;
            }
          }
          return null;
        }
        if (typeof node !== "object") {
          return null;
        }
        var preferredKeys = [
          "resultImageBase64",
          "result_image_base64",
          "image",
          "result_image",
          "image_base64",
          "result",
          "output",
          "data",
          "url",
          "image_url",
          "result_url"
        ];
        var k;
        for (k = 0; k < preferredKeys.length; k++) {
          if (node[preferredKeys[k]] != null) {
            var fromKey = findDecodableImageFromJson(node[preferredKeys[k]], depth + 1);
            if (fromKey) {
              return fromKey;
            }
          }
        }
        for (var key in node) {
          if (Object.prototype.hasOwnProperty.call(node, key)) {
            var nested = findDecodableImageFromJson(node[key], depth + 1);
            if (nested) {
              return nested;
            }
          }
        }
        return null;
      }
  
      function rawBase64ToBlob(base64, mimeType) {
        if (!base64 || typeof base64 !== "string") {
          return null;
        }
        var normalized = base64.trim();
        if (!normalized) {
          return null;
        }
        if (normalized.indexOf("data:") === 0) {
          return dataUrlToBlob(normalized);
        }
        var mime = mimeType && typeof mimeType === "string" ? mimeType.trim() : "image/png";
        return dataUrlToBlob("data:" + mime + ";base64," + normalized);
      }
  
      async function parseTryonSuccessResponse(response) {
        var contentType = (response.headers.get("Content-Type") || "").toLowerCase();
        if (contentType.indexOf("image/") !== -1) {
          return response.blob();
        }
        var bodyText = await response.text();
        var data = null;
        try {
          data = JSON.parse(bodyText);
        } catch (parseErr) {
          throw new Error("Try-on API returned a non-image, non-JSON response.");
        }
        if (data && data.success === false) {
          throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
        }
        if (data && typeof data.resultImageBase64 === "string" && data.resultImageBase64.trim()) {
          var resultBlob = rawBase64ToBlob(data.resultImageBase64, data.mimeType);
          if (resultBlob && resultBlob.size > 0) {
            return resultBlob;
          }
          throw new Error("Try-on API returned an invalid result image.");
        }
        var blob = findDecodableImageFromJson(data);
        if (blob) {
          return blob;
        }
        var urlCandidate =
          data &&
          (data.result_url ||
            data.image_url ||
            data.url ||
            (data.output && (data.output.url || data.output.result_url)));
        if (urlCandidate && typeof urlCandidate === "string") {
          return urlToBlob(urlCandidate);
        }
        throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
      }
  
      async function urlToBlob(imageUrl) {
        var response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error("Could not load generated image.");
        }
        return response.blob();
      }
  
      function dataUrlToBlob(value) {
        if (!value || typeof value !== "string") {
          return null;
        }
  
        var normalized = value.trim();
        if (!normalized) {
          return null;
        }
  
        // Support both full data URLs and raw base64 payloads.
        if (normalized.indexOf("data:") !== 0) {
          normalized = "data:image/jpeg;base64," + normalized;
        }
  
        var parts = normalized.split(",");
        if (parts.length < 2) {
          return null;
        }
  
        var header = parts[0];
        var base64 = parts.slice(1).join(",");
        var mimeMatch = header.match(/data:(.*?);base64/);
        var mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : "image/jpeg";
        var binary = atob(base64);
        var length = binary.length;
        var bytes = new Uint8Array(length);
  
        for (var i = 0; i < length; i += 1) {
          bytes[i] = binary.charCodeAt(i);
        }
  
        return new Blob([bytes], { type: mimeType });
      }
  
      async function imageFromUrl(imageUrl, useCrossOrigin) {
        return new Promise(function (resolve, reject) {
          var image = new Image();
          if (useCrossOrigin) {
            image.crossOrigin = "anonymous";
          }
          image.onload = function () {
            resolve(image);
          };
          image.onerror = function () {
            reject(new Error("Failed to decode image."));
          };
          image.src = imageUrl;
        });
      }
  
      async function applyWatermark(inputBlob) {
        try {
          var sourceUrl = URL.createObjectURL(inputBlob);
          var sourceImage = await imageFromUrl(sourceUrl);
          URL.revokeObjectURL(sourceUrl);
  
          var tempCanvas = document.createElement("canvas");
          tempCanvas.width = sourceImage.width;
          tempCanvas.height = sourceImage.height;
          var ctx = tempCanvas.getContext("2d");
          ctx.drawImage(sourceImage, 0, 0, sourceImage.width, sourceImage.height);
  
          var fontSize = Math.max(22, Math.round(sourceImage.width * 0.06));
          ctx.save();
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          ctx.font = "700 " + fontSize + "px Arial, sans-serif";
          ctx.lineWidth = Math.max(2, Math.round(fontSize * 0.08));
          ctx.strokeStyle = "rgba(0, 0, 0, 0.24)";
          ctx.fillStyle = "rgba(255, 255, 255, 0.4)";
          ctx.strokeText("SUHAS GROVER", sourceImage.width / 2, sourceImage.height - 3);
          ctx.fillText("SUHAS GROVER", sourceImage.width / 2, sourceImage.height - 3);
          ctx.restore();
  
          var finalBlob = await new Promise(function (resolve) {
            tempCanvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
          });
          if (!finalBlob) {
            console.warn("[TryOn] Canvas toBlob returned null. Returning original image.");
          }
          return finalBlob || inputBlob;
        } catch (error) {
          console.error("[TryOn] Watermark apply failed.", error);
          return inputBlob;
        }
      }
  
      function submitCustomerDetails(payload) {
        var url = modal.dataset.detailsEndpoint;
        if (!url || !payload) {
          console.warn("[TryOn] Sheet submit skipped: missing endpoint or payload.", { url: !!url, payload: !!payload });
          return Promise.resolve();
        }
        var meta = getProductSubmissionMeta();
        var dialCode =
          payload.code != null && String(payload.code).trim()
            ? String(payload.code).trim()
            : getDialCodeForRegion(payload.countryCode || "");
        var nationalPhone = normalizePhoneDigits(payload.phone);
        var bodyObj = {
          name: String(payload.name || "").trim(),
          code: dialCode,
          phone: nationalPhone,
          productUrl: meta.productUrl,
          productName: meta.productName
        };

        return submitToGoogleSheet(url, bodyObj);
      }

      /** POST JSON in request body — read by Apps Script e.postData.contents */
      function submitToGoogleSheet(url, bodyObj) {
        var body = JSON.stringify(bodyObj);
        return fetch(url, {
          method: "POST",
          mode: "no-cors",
          cache: "no-store",
          headers: {
            "Content-Type": "text/plain;charset=utf-8"
          },
          body: body
        })
          .then(function (response) {
            if (response.type === "opaque") {
              return;
            }
            if (!response.ok) {
              console.warn("[TryOn] Sheet endpoint HTTP error:", response.status, response.statusText);
            }
          })
          .catch(function (error) {
            console.error("[TryOn] Sheet submit failure:", error && error.message ? error.message : error);
          });
      }
  
      function downloadBlob(blob, filename) {
        var fileUrl = URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = fileUrl;
        anchor.download = filename || "try-on-result.jpg";
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(fileUrl);
      }
  
      function askCustomerDetails(actionLabel) {
        if (!detailsModal || !detailsNameInput || !detailsPhoneInput || !detailsSubmitButton || !detailsCancelButton) {
          return Promise.resolve(null);
        }
  
        return new Promise(function (resolve) {
          function closePopup(result) {
            setDetailsSubmitBusy(false);
            detailsModal.hidden = true;
            modal.classList.remove("br-tryon-modal--details-open");
            detailsSubmitButton.removeEventListener("click", submitHandler);
            detailsCancelButton.removeEventListener("click", cancelHandler);
            detailsModal.removeEventListener("click", overlayHandler);
            resolve(result);
          }
  
          function submitHandler() {
            if (isDetailsSubmitBusy) {
              return;
            }
            var name = (detailsNameInput.value || "").trim();
            var phoneNational = normalizePhoneDigits(detailsPhoneInput.value);
            var phoneRegion = getSelectedPhoneRegion();
            detailsPhoneInput.value = phoneNational;
            var missingName = !name;
            var missingPhone = !phoneNational;
            var invalidPhone = !validatePhoneForRegion(phoneNational, phoneRegion);
            var consentGiven = detailsConsentInput && detailsConsentInput.checked;
            var phoneE164 = formatPhoneE164(phoneNational, phoneRegion);

            setInputErrorState(detailsNameInput, missingName);
            setInputErrorState(detailsPhoneInput, missingPhone || invalidPhone);
            setInputErrorState(detailsPhoneCountry, missingPhone || invalidPhone);

            if (!name || !phoneNational) {
              setDetailsError("Please enter both name and mobile number.");
              return;
            }
            if (invalidPhone || !phoneE164) {
              setDetailsError("Enter a valid mobile number for the selected country.");
              return;
            }
            if (!consentGiven) {
              setDetailsError("Please give consent for suhasgrover team to contact.");
              return;
            }
            setDetailsError("");
            var dialCode = getSelectedDialCode();
            var payload = {
              name: name,
              phone: phoneNational,
              code: dialCode,
              countryCode: phoneRegion,
              phoneE164: phoneE164,
              consent: true
            };
            setDetailsSubmitBusy(true, getDetailsBusyLabel(actionLabel));
            persistContactSubmitted(payload);
            submitCustomerDetails(payload).finally(function () {
              closePopup(payload);
            });
          }
  
          function cancelHandler() {
            if (isDetailsSubmitBusy) {
              return;
            }
            closePopup(null);
          }
  
          function overlayHandler(event) {
            if (event.target === detailsModal) {
              if (isDetailsSubmitBusy) {
                return;
              }
              closePopup(null);
            }
          }
  
          detailsNameInput.value = "";
          detailsPhoneInput.value = "";
          ensureGlobalPhoneCountrySelect(detailsPhoneCountry);
          if (detailsPhoneCountry) {
            var defaultCountry = detailsPhoneCountry.getAttribute("data-default-country");
            if (defaultCountry) {
              detailsPhoneCountry.value = String(defaultCountry).toUpperCase();
            }
          }
          applyDefaultPhoneFromCustomer();
          if (detailsConsentInput) {
            detailsConsentInput.checked = false;
          }
          setInputErrorState(detailsNameInput, false);
          setInputErrorState(detailsPhoneInput, false);
          if (detailsPhoneCountry) {
            setInputErrorState(detailsPhoneCountry, false);
          }
          setDetailsError("");
          if (actionLabel === "share") {
            detailsSubmitLabel = "Share";
          } else if (actionLabel === "generate") {
            detailsSubmitLabel = "Generate";
          } else {
            detailsSubmitLabel = "Download";
          }
          setDetailsSubmitBusy(false);
          detailsSubmitButton.textContent = detailsSubmitLabel;
          var headline;
          if (actionLabel === "share") {
            headline = "Share details before sharing the image";
          } else if (actionLabel === "generate") {
            headline = "Contact details required for another try-on";
          } else {
            headline = "Share details before downloading the image";
          }
          if (detailsTitleEl) {
            detailsTitleEl.textContent = headline;
          }
          if (detailsInnerDialog) {
            detailsInnerDialog.setAttribute("aria-label", headline);
          }
          detailsModal.hidden = false;
          modal.classList.add("br-tryon-modal--details-open");
          detailsModal.addEventListener("click", overlayHandler);
          detailsSubmitButton.addEventListener("click", submitHandler);
          detailsCancelButton.addEventListener("click", cancelHandler);
          if (actionLabel === "share") {
            setStatus("Enter your details to share.");
          } else if (actionLabel === "generate") {
            setStatus("Enter your details to generate another try-on.");
          } else {
            setStatus("Enter your details to download.");
          }
          detailsNameInput.focus();
        });
      }
  
      async function handleDownload() {
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (!generatedBlob) {
          setStatus("Generate image first.");
          return;
        }
        var dailyState = readDailyState();
        var details = dailyState.contact;
        if (!dailyState.contactSubmitted) {
          details = await askCustomerDetails("download");
          if (!details) {
            setStatus("Download cancelled.");
            return;
          }
        }
        setToolbarActionLoading(true, "Downloading…");
        setStatus("");
        try {
          await nextPaint();
          downloadBlob(generatedBlob, generatedFilename);
          setStatus(details && details.name ? "Downloaded for " + details.name + "." : "Downloaded.");
        } catch (err) {
          setStatus("Download failed.", "error");
          console.error("[TryOn] Download error:", err);
        } finally {
          setToolbarActionLoading(false);
        }
      }
  
      async function handleShare() {
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (!generatedBlob) {
          setStatus("Generate image first.");
          return;
        }
        var dailyStateShare = readDailyState();
        var details = dailyStateShare.contact;
        if (!dailyStateShare.contactSubmitted) {
          details = await askCustomerDetails("share");
          if (!details) {
            setStatus("Share cancelled.");
            return;
          }
        }
  
        var shareFile = new File([generatedBlob], generatedFilename, { type: "image/jpeg" });
        var shareText =
          details && details.name
            ? "Generated for " + details.name + (details.phone ? " (" + details.phone + ")" : "")
            : "Try-On Result";
        if (navigator.canShare && navigator.canShare({ files: [shareFile] })) {
          setToolbarActionLoading(true, "Sharing…");
          setStatus("");
          try {
            await navigator.share({
              title: "Try-On Result",
              text: shareText,
              files: [shareFile]
            });
            setStatus("Shared successfully.");
          } catch (error) {
            setStatus("Share cancelled.");
          } finally {
            setToolbarActionLoading(false);
          }
        } else {
          setToolbarActionLoading(true, "Downloading…");
          setStatus("");
          try {
            await nextPaint();
            downloadBlob(generatedBlob, generatedFilename);
            setStatus("Share unsupported. Downloaded instead.");
          } catch (err) {
            setStatus("Download failed.", "error");
            console.error("[TryOn] Download error:", err);
          } finally {
            setToolbarActionLoading(false);
          }
        }
      }
  
      /**
       * One rule for camera, upload, and regenerate:
       * - contact already submitted today → never ask
       * - first successful generate today (count 0) → free, no ask
       * - any further generate/regenerate → ask once if not submitted
       */
      async function ensureContactForTryOn(statusMessage) {
        var state = readDailyState();
        if (state.contactSubmitted) {
          return true;
        }
        if (state.generationCount < 1) {
          return true;
        }
        var details = await askCustomerDetails("generate");
        if (!details) {
          setStatus("Contact details are required for another try-on.");
          return false;
        }
        setStatus(statusMessage || "Generating try-on result...");
        setLoading(true);
        return true;
      }
  
      async function requestGeneration(fileBlob, options) {
        options = options || {};
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        var contactOk = await ensureContactForTryOn(options.statusMessage);
        if (!contactOk) {
          return;
        }
        await sendToApi(fileBlob);
      }
  
      async function sendToApi(fileBlob) {
        var endpoint = modal.dataset.apiEndpoint;
        var apiKey = modal.dataset.apiKey || modal.dataset.apiAuth;
        if (!endpoint) {
          setStatus("API endpoint missing.");
          return;
        }
        if (!apiKey) {
          setStatus("API key missing.");
          return;
        }
  
        var garmentUrl = syncGarmentImage();
        if (!garmentUrl) {
          setStatus("Garment image missing.");
          return;
        }
  
        setStatus("Preparing images...");
        setLoading(true);
        var personEncoded;
        var garmentEncoded;
        try {
          personEncoded = await blobToJpegBase64(fileBlob);
          garmentEncoded = await imageUrlToJpegBase64(garmentUrl);
        } catch (prepErr) {
          setLoading(false);
          setStatus(
            (prepErr && prepErr.message) || "Could not prepare images for try-on.",
            "error"
          );
          console.error("[TryOn] Image prep error:", prepErr);
          return;
        }
  
        if (!personEncoded.base64 || !garmentEncoded.base64) {
          setLoading(false);
          setStatus("Could not prepare model or garment image.", "error");
          return;
        }
  
        var resolution = String(modal.dataset.tryonResolution || "1K").trim().toUpperCase();
        if (resolution !== "1K" && resolution !== "2K" && resolution !== "4K") {
          resolution = "1K";
        }
  
        var payload = {
          personImage: personEncoded.base64,
          garmentMimeType: garmentEncoded.mimeType || "image/jpeg",
          garmentImage: garmentEncoded.base64,
          resolution: resolution
        };
  
        setStatus("Generating try-on result...");
        var abortController = new AbortController();
        var abortTimer = setTimeout(function () { abortController.abort(); }, 600000);
        try {
          var response = await fetch(endpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": apiKey
            },
            body: JSON.stringify(payload),
            signal: abortController.signal
          });
          clearTimeout(abortTimer);
  
          var errBodyText = "";
          if (!response.ok) {
            try {
              errBodyText = await response.text();
            } catch (readErr) {
              console.warn("[TryOn] Could not read API error body:", readErr);
            }
            var errJson = null;
            if (errBodyText) {
              try {
                errJson = JSON.parse(errBodyText);
              } catch (parseErr) {
                /* use raw body text below */
              }
            }
            var errMsg = extractTryonApiErrorMessage(errJson, errBodyText, response.status);
            console.warn("[TryOn] API HTTP error:", response.status, errMsg, errBodyText || errJson);
            throw new Error(errMsg);
          }
  
          var apiResultBlob = await parseTryonSuccessResponse(response);
          if (!apiResultBlob) {
            throw new Error("No result image in API response.");
          }
          var finalBlob = await applyWatermark(apiResultBlob);
          generatedBlob = finalBlob;
          generatedFilename = "try-on-" + Date.now() + ".jpg";
          resultImage.src = URL.createObjectURL(finalBlob);
          setUploadState("result");
          setStatus("Try-on ready.");
          incrementSuccessfulGenerationCount();
        } catch (error) {
          clearTimeout(abortTimer);
          var msg =
            error && error.name === "AbortError"
              ? "Request timed out after 10 minutes. Please retry."
              : (error && error.message && String(error.message).trim()) ||
                "Try-on failed. Please retry.";
          setStatus(msg, "error");
          console.error("[TryOn] Try-on error:", msg, error);
        } finally {
          setLoading(false);
        }
      }
  
      function waitForVideoFrameReady(v, maxMs) {
        maxMs = maxMs || 500;
        if (v.videoWidth >= 2 && v.videoHeight >= 2 && v.readyState >= 2) {
          return Promise.resolve();
        }
        return new Promise(function (resolve) {
          var finished = false;
          function done() {
            if (finished) {
              return;
            }
            finished = true;
            v.removeEventListener("loadeddata", onReady);
            v.removeEventListener("canplay", onReady);
            v.removeEventListener("resize", onReady);
            clearTimeout(tid);
            resolve();
          }
          function onReady() {
            if (v.videoWidth >= 2 && v.videoHeight >= 2) {
              done();
            }
          }
          v.addEventListener("loadeddata", onReady);
          v.addEventListener("canplay", onReady);
          v.addEventListener("resize", onReady);
          var tid = setTimeout(done, maxMs);
        });
      }
  
      function waitNextVideoFrame(el) {
        return new Promise(function (resolve) {
          if (!el) {
            resolve();
            return;
          }
          if (typeof el.requestVideoFrameCallback === "function") {
            el.requestVideoFrameCallback(function () {
              resolve();
            });
          } else {
            requestAnimationFrame(function () {
              resolve();
            });
          }
        });
      }
  
      async function ensureVideoPlaying(v) {
        if (!v) {
          return;
        }
        try {
          if (v.paused) {
            await v.play();
          }
        } catch (playErr) {
          /* stream already playing in most cases */
        }
      }
  
      async function captureFromCamera() {
        if (!video || !canvas) {
          return;
        }
  
        await ensureVideoPlaying(video);
  
        var maxAttempts = cameraFacingMode === "environment" ? 5 : 3;
        var width = 0;
        var height = 0;
        var a = 0;
        for (a = 0; a < maxAttempts; a++) {
          try {
            await waitForVideoFrameReady(video, 1000);
          } catch (waitErr) {
            /* continue */
          }
          await ensureVideoPlaying(video);
          await waitNextVideoFrame(video);
          await waitNextVideoFrame(video);
          width = video.videoWidth || 0;
          height = video.videoHeight || 0;
          if (width >= 2 && height >= 2) {
            break;
          }
          await new Promise(function (r) {
            setTimeout(r, 180 + a * 120);
          });
        }
  
        if (width < 2 || height < 2) {
          setStatus("Could not read camera frame. Tap Camera to retry or use Choose Photo.");
          return;
        }
        var crop = getCaptureCrop(width, height);
        var targetSize = getTargetCaptureSize();
        canvas.width = targetSize.width;
        canvas.height = targetSize.height;
        var context = canvas.getContext("2d");
        context.drawImage(video, crop.sx, crop.sy, crop.sw, crop.sh, 0, 0, targetSize.width, targetSize.height);
  
        var blob = await new Promise(function (resolve) {
          canvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
        });
  
        if (!blob) {
          setStatus("Could not capture image.");
          return;
        }
  
        stopCamera();
        lastSourceBlob = blob;
        previewImage.src = URL.createObjectURL(blob);
        setUploadState("preview");
        setStatus("Captured. Sending to try-on...");
        requestGeneration(blob);
      }
  
      async function startCameraAndAutoCapture() {
        stopCamera();
        cameraFacingMode = "user";
        syncGarmentImage();
        setStatus("Requesting camera permission...");
  
        try {
          await ensurePoseReady();
          await attachLiveCameraStream();
          syncPoseConfidenceForFacing();
          setUploadState("camera");
          setStatus("Stand in middle for accurate outputs.");
          setCameraInstruction("Stand in middle for accurate outputs.");
          poseLoopActive = true;
          runPoseLoop();
          startBodyMonitor();
        } catch (error) {
          setStatus("Camera permission denied or unavailable.");
        }
      }
  
      function resetCameraCountdownState() {
        if (countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
        setCountdownValue("");
        bodySeenStreak = 0;
        bodyLostStreak = 0;
      }
  
      async function flipCameraFacing(event) {
        if (event) {
          event.stopPropagation();
        }
        if (currentState !== "camera" || isLoading || !poseLoopActive || !video) {
          return;
        }
        var previousMode = cameraFacingMode;
        cameraFacingMode = previousMode === "user" ? "environment" : "user";
        setStatus("Switching camera…");
        try {
          if (stream) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            stream = null;
          }
          await attachLiveCameraStream();
          syncPoseConfidenceForFacing();
          resetCameraCountdownState();
          latestPoseLandmarks = null;
          if (cameraFacingMode === "environment") {
            setStatus("Back camera — step back, full body in frame.");
            setCameraInstruction("Auto-capture when preview is ready.");
          } else {
            setStatus("Stand in middle for accurate outputs.");
            setCameraInstruction("Stand in middle for accurate outputs.");
          }
        } catch (err) {
          cameraFacingMode = previousMode;
          try {
            await attachLiveCameraStream();
            syncPoseConfidenceForFacing();
            resetCameraCountdownState();
            latestPoseLandmarks = null;
            if (cameraFacingMode === "environment") {
              setStatus("Back camera — step back, full body in frame.");
              setCameraInstruction("Auto-capture when preview is ready.");
            } else {
              setStatus("Stand in middle for accurate outputs.");
              setCameraInstruction("Stand in middle for accurate outputs.");
            }
          } catch (err2) {
            setStatus("Could not switch camera. Try again.", "error");
            console.warn("[TryOn] Flip camera failed:", err, err2);
          }
        }
      }
  
      function openModal(triggerButton) {
        activeGarmentOverride = "";
        var garmentFromButton = getGarmentUrlFromButton(triggerButton);
        if (garmentFromButton) {
          activeGarmentOverride = garmentFromButton;
        }
        var garmentUrl = syncGarmentImage();
        if (!garmentUrl && garmentFromButton) {
          activeGarmentOverride = garmentFromButton;
          garmentUrl = syncGarmentImage();
        }
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        showPageBackdrop();
        document.body.classList.add("overflow-hidden");
        document.documentElement.classList.add("br-tryon-modal-open");
        if (!contextMenuBlocker) {
          contextMenuBlocker = function (event) {
            if (modal.classList.contains("is-open")) {
              event.preventDefault();
            }
          };
        }
        document.addEventListener("contextmenu", contextMenuBlocker);
        setUploadState("empty");
        setLoading(false);
        setToolbarActionLoading(false);
        cameraFacingMode = "user";
        setStatus("Choose camera or upload to start try-on.");
        previewImage.src = "";
        resultImage.src = "";
      }
  
      function closeModal() {
        activeGarmentOverride = "";
        modal.classList.remove("is-open");
        modal.classList.remove("br-tryon-modal--details-open");
        modal.setAttribute("aria-hidden", "true");
        hidePageBackdrop();
        document.body.classList.remove("overflow-hidden");
        document.documentElement.classList.remove("br-tryon-modal-open");
        if (contextMenuBlocker) {
          document.removeEventListener("contextmenu", contextMenuBlocker);
        }
        if (detailsModal) {
          detailsModal.hidden = true;
        }
        setToolbarActionLoading(false);
        stopCamera();
      }
  
      openButtons.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          openModal(btn);
        });
      });
      closeButtons.forEach(function (button) {
        button.addEventListener("click", closeModal);
      });
  
      cameraButton.addEventListener("click", startCameraAndAutoCapture);
      chooseButton.addEventListener("click", function () {
        fileInput.click();
      });
  
      uploadBox.addEventListener("click", function (event) {
        if (event.target && event.target.closest(".br-tryon-toolbar-stack")) {
          return;
        }
        if (event.target && event.target.closest(".br-tryon-camera-flip-row")) {
          return;
        }
        if (event.target && event.target.closest(".br-tryon-capture-btn-row")) {
          return;
        }
        if (detailsModal && !detailsModal.hidden) {
          return;
        }
        if (currentState !== "camera") {
          fileInput.click();
        }
      });
  
      fileInput.addEventListener("change", function (event) {
        var file = event.target.files && event.target.files[0];
        if (!file) {
          return;
        }
  
        stopCamera();
        lastSourceBlob = file;
        previewImage.src = URL.createObjectURL(file);
        setUploadState("preview");
        setStatus("Uploading selected photo...");
        requestGeneration(file);
      });
  
      regenerateButton.addEventListener("click", function () {
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (!lastSourceBlob) {
          setStatus("Capture or upload first, then regenerate.");
          return;
        }
        requestGeneration(lastSourceBlob, { statusMessage: "Regenerating..." });
      });
  
      if (captureButton) {
        captureButton.addEventListener("click", function (event) {
          event.stopPropagation();
          if (currentState !== "camera" || isCameraCaptureInProgress || isLoading) {
            return;
          }
          if (!hasHalfBodyInView()) {
            setStatus("Please stand properly in frame before capturing.", "error");
            return;
          }
          isCameraCaptureInProgress = true;
          captureFromCamera().finally(function () {
            isCameraCaptureInProgress = false;
          });
        });
      }

      [shareButton, downloadButton, regenerateButton, cameraFlipButton].forEach(function (button) {
        if (!button) {
          return;
        }
        button.addEventListener("click", function (event) {
          event.stopPropagation();
        });
      });
  
      if (cameraFlipButton) {
        cameraFlipButton.addEventListener("click", flipCameraFacing);
      }
  
      downloadButton.addEventListener("click", handleDownload);
      shareButton.addEventListener("click", handleShare);
  
      modal.addEventListener("click", function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });
  
      document.addEventListener("variant:change", function () {
        activeGarmentOverride = "";
        syncGarmentImage();
      });

      var detailRoot = getProductDetailRoot();
      if (detailRoot) {
        detailRoot.addEventListener("click", function (event) {
          if (
            event.target.closest(
              ".thumbnail-list, .thumbnail-list__item, button.thumbnail, .slider-button, .product__media-item"
            )
          ) {
            activeGarmentOverride = "";
            window.setTimeout(syncGarmentImage, 0);
            window.setTimeout(syncGarmentImage, 120);
          }
        });

        var galleryList = detailRoot.querySelector(".product__media-list, .product__media-wrapper, media-gallery");
        if (galleryList && typeof MutationObserver !== "undefined") {
          var galleryObserver = new MutationObserver(function () {
            if (modal.classList.contains("is-open")) {
              activeGarmentOverride = "";
            }
            syncGarmentImage();
          });
          galleryObserver.observe(galleryList, {
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "aria-current", "aria-hidden"]
          });
        }
      }
  
    }
  
    function boot() {
      document.querySelectorAll("[data-tryon-root]").forEach(initTryOn);
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  })();
  